
import {Component, Vue} from 'vue-property-decorator'
import UserInfo from '@/model/modules/UserInfo'
import UserInfoService from '@/service/modules/UserInfoService'
import UserChargeInfo from '@/model/modules/UserChargeInfo'

@Component
export default class UserLevelGroupEditor extends Vue {
  item: UserInfo = new UserInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any
  userChargeInfo: UserChargeInfo = new UserChargeInfo()

  showEditor(item: UserInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.item.totalPrice /= 100
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
  }

  saveEditor() {
    this.savingState = true
    const chargeInfo: UserChargeInfo = JSON.parse(JSON.stringify(this.userChargeInfo))
    chargeInfo.userId = this.item.id
    chargeInfo.price = Math.floor(chargeInfo.price * 100)
    UserInfoService.charge(chargeInfo)
      .then(() => {
        this.$alert('充值成功！', '用户余额充值', {
          confirmButtonText: '确定'
        })
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
